/*jshint esversion: 11 */
import React, { useEffect, useRef } from 'react';
import MetisMenu from 'metismenujs';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changePreloader
} from '../../store/actions';
import {
  VIEW_ACTIVITIES,
  VIEW_ASSIGNMENTS,
  VIEW_BADGES,
  VIEW_BATCH,
  VIEW_BOOKS,
  VIEW_CHILDREN,
  VIEW_FEEDBACKS,
  VIEW_OFFERINGS,
  VIEW_PARENTS,
  VIEW_QUESTIONS,
  VIEW_ROLE,
  VIEW_ATTRIBUTES,
  VIEW_STAFF,
  VIEW_TAGS,
  VIEW_TOYS,
  VIEW_WEEKLY_ACTION_RECORD_TEMPLATE,
  VIEW_BATCH_IMAGE,
  VIEW_PARENT_QUERY,
  VIEW_EXECUTIONS,
  VIEW_SURVEY,
  VIEW_TRANSACTION
} from '../../pages/Utility/PermissionKeys';
import { validatePermissionKey } from '../../helpers/permission';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const SidebarContent = (props) => {
  const menuRef = useRef(null);
  const history = useHistory();
  const activateParentDropdown = (item) => {
    item.classList.add('active');
    const parent = item.parentElement;

    if (parent) {
      parent.classList.add('mm-active');
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add('mm-show');

        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add('mm-active');
          parent3.childNodes[0].classList.add('mm-active');
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add('mm-active');
          }
        }
      }
      return false;
    }
    return false;
  };

  useEffect(() => {
    const initMenu = () => {
      if (menuRef.current) {
        menuRef.current.dispose();
      }

      menuRef.current = new MetisMenu('#side-menu');

      const currentPath = props.location.pathname;
      const links = document.querySelectorAll('#side-menu a');

      let bestMatch = null;

      links.forEach((link) => {
        const href = link.getAttribute('href');
        if (!href || href === '#') return;

        if (currentPath === href || currentPath.startsWith(href + '/')) {
          if (!bestMatch || href.length > bestMatch.getAttribute('href').length) {
            bestMatch = link;
          }
        }
      });

      if (bestMatch) {
        activateParentDropdown(bestMatch);
        bestMatch.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    };

    initMenu();

    return () => {
      if (menuRef.current) {
        menuRef.current.dispose();
      }
    };
  }, [props.type, props.location]);

  return (
    <React.Fragment>
      <div id="sidebar-menu">
        <ul className="metismenu list-unstyled" id="side-menu">
          <li id="homeList">
            <Link to="/#" className="has-arrow waves-effect" onClick={() => history.push('/dashboard')}>
              <i className="ri-dashboard-line"></i>
              <span className="ml-1">Home</span>
            </Link>
            <ul className="sub-menu" aria-expanded="false">
              <li>
                <Link to="/dashboard" className="waves-effect">
                  <span className="ml-1">Home</span>
                </Link>
              </li>
              {validatePermissionKey(props.authUser, VIEW_TAGS) && (
                <li id="tagList">
                  <Link id="tagLink" to="/tags" className="waves-effect">
                    {/* <i className="ri-price-tag-3-fill  "></i> */}
                    <span className="ml-1">Tags</span>
                  </Link>
                </li>
              )}
            </ul>
          </li>
          {validatePermissionKey(props.authUser, VIEW_OFFERINGS) && (
            <li>
              <Link to="/#" className="has-arrow waves-effect" onClick={() => history.push('/offerings')}>
                <i className="ri-bubble-chart-fill"></i>
                <span className="ml-1">Offerings</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/offerings" className="waves-effect">
                    <span className="ml-1">All Offerings</span>
                  </Link>
                </li>
                {validatePermissionKey(
                  props.authUser,
                  VIEW_WEEKLY_ACTION_RECORD_TEMPLATE
                ) && (
                    <li>
                      <Link
                        to="/weekly-action-record-template"
                        className="waves-effect"
                      >
                        <span className="ml-1">Weekly Record Template</span>
                      </Link>
                    </li>
                  )}
              </ul>
            </li>
          )}

          {validatePermissionKey(props.authUser, VIEW_BATCH) && (
            <li>
              <Link to="/#" className="has-arrow waves-effect" onClick={() => history.push('/batches')}>
                <i className="ri-bubble-chart-fill"></i>
                <span className="ml-1">Batch</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/batches" className="waves-effect">
                    <span className="ml-1">All Batches</span>
                  </Link>
                </li>
                {validatePermissionKey(
                  props.authUser,
                  VIEW_BATCH_IMAGE
                ) && (
                    <li>
                      <Link to="/batches/images" className="waves-effect">
                        <span className="ml-1">Batch Images</span>
                      </Link>
                    </li>
                  )}
                {validatePermissionKey(
                  props.authUser,
                  VIEW_EXECUTIONS
                ) && (
                    <li>
                      <Link to="/batches/executions" className="waves-effect">
                        <span className="ml-1">Batch Executions</span>
                      </Link>
                    </li>
                  )}
              </ul>
            </li>
          )}
          {validatePermissionKey(props.authUser, VIEW_ROLE) && (
            <li id="roleList">
              <Link to="/roles" id="roleLink" className="waves-effect">
                <i className="fas fa-user-shield"></i>
                <span className="ml-1">Roles</span>
              </Link>
            </li>
          )}
          {validatePermissionKey(props.authUser, VIEW_STAFF) && (
            <li id="staffList">
              <Link to="/staff" id="staffLink" className="waves-effect">
                <i className="ri-team-fill"></i>
                <span className="ml-1">Staffs</span>
              </Link>
            </li>
          )}

          {/* {validatePermissionKey(props.authUser, VIEW_PARENTS) && (
            <li>
              <Link to="/#" className="has-arrow waves-effect" onClick={() => history.push('/parents')}>
                <i className="ri-parent-fill "></i>
                <span className="ml-1">Parents</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/parents" className="waves-effect">
                    <span className="ml-1">All Parents</span>
                  </Link>
                </li>
                {validatePermissionKey(
                  props.authUser,
                  VIEW_PARENT_QUERY
                ) && (
                    <li>
                      <Link to="/parent-query" className="waves-effect">
                        <span className="ml-1">Parent Queries</span>
                      </Link>
                    </li>
                  )}
              </ul>
            </li>
          )} */}

          {validatePermissionKey(props.authUser, VIEW_CHILDREN) && (
            <li id="childList">
              <Link to="/#" className="has-arrow waves-effect" onClick={() => history.push('/children')}>
                <i className="ri-account-box-fill "></i>
                <span className="ml-1">Children</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link
                    to="/children"
                    cid="childLink"
                    className="waves-effect"
                  >
                    <span className="ml-1">Children</span>
                  </Link>
                </li>
                {validatePermissionKey(props.authUser, VIEW_SURVEY) && (
                  <li>
                    <Link to="/surveys" className="waves-effect">
                      <span className="ml-1">Child Survey</span>
                    </Link>
                  </li>
                )}
                {validatePermissionKey(props.authUser, VIEW_PARENTS) && (
                  <li>
                    <Link to="/parents" className="waves-effect" >
                      {/* <i className="ri-parent-fill "></i> */}
                      <span className="ml-1">Parents</span>
                    </Link>
                  </li>
                )}
                {validatePermissionKey(props.authUser, VIEW_TRANSACTION) && (
                  <li id="transactionList">
                    <Link
                      id="transactionList"
                      to="/transactions"
                      className="waves-effect"
                    >
                      {/* <i className="fas fa-receipt"></i> */}
                      <span className="ml-1">Transactions</span>
                    </Link>
                  </li>
                )}
              </ul>
            </li>
          )}

          <li id="homeList">
            <Link to="/#" className="has-arrow waves-effect">
              <i className="ri-dashboard-line"></i>
              <span className="ml-1">Communication</span>
            </Link>
            <ul className="sub-menu" aria-expanded="false">
              {validatePermissionKey(props.authUser, VIEW_ASSIGNMENTS) && (
                <li id="assignmentList">
                  <Link
                    id="assignmentLink"
                    to="/assignments"
                    className="waves-effect"
                  >
                    {/* <i className="ri-survey-fill "></i> */}
                    <span className="ml-1">Assignments</span>
                  </Link>
                </li>
              )}
              {validatePermissionKey(props.authUser, VIEW_FEEDBACKS) && (
                <li id="feedbackList">
                  <Link
                    id="feedbackLink"
                    to="/feedbacks"
                    className="waves-effect"
                  >
                    <span className="ml-1">Feedback</span>
                  </Link>
                </li>
              )}
              {validatePermissionKey(
                props.authUser,
                VIEW_PARENT_QUERY
              ) && (
                  <li>
                    <Link to="/parent-query" className="waves-effect">
                      <span className="ml-1">Parent Queries</span>
                    </Link>
                  </li>
                )}

              <li id="todoList">
                <Link to="/todos" id="todoLink" className="waves-effect">
                  {/* <i className="ri-todo-fill "></i> */}
                  <span className="ml-1">Todo</span>
                </Link>
              </li>
            </ul>
          </li>

          {validatePermissionKey(props.authUser, VIEW_ACTIVITIES) && (
            <li id="activityList">
              <Link
                id="activityLink"
                to="/activities"
                className="waves-effect"
              >
                <i className="ri-palette-fill "></i>
                <span className="ml-1">Activities</span>
              </Link>
            </li>
          )}

          <li>
            <Link to="/#" className="has-arrow waves-effect">
              <i className="fas fa-award"></i>
              <span className="ml-1">Learner's Profile</span>
            </Link>
            <ul className="sub-menu" aria-expanded="false">
              <li>
                {validatePermissionKey(props.authUser, VIEW_BADGES) && (
                  <Link id="badgeLink" to="/badges" className="waves-effect">
                    <span className="ml-1">Badges</span>
                  </Link>
                )}
              </li>
              <li>
                {validatePermissionKey(
                  props.authUser,
                  VIEW_QUESTIONS
                ) && (
                    <Link
                      id="questionLink"
                      to="/questions"
                      className="waves-effect"
                    >
                      <span className="ml-1">Question</span>
                    </Link>
                  )}
              </li>
              <li>
                {validatePermissionKey(
                  props.authUser,
                  VIEW_ATTRIBUTES
                ) && (
                    <Link
                      id="sectionLink"
                      to="/section"
                      className="waves-effect"
                    >
                      <span className="ml-1">Attributes</span>
                    </Link>
                  )}
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </React.Fragment>
  );
};

// {validatePermissionKey(props.authUser, VIEW_TOYS) && (
//             <li id="toyList">
//               <Link id="toyLink" to="/toys" className="waves-effect">
//                 <i className="ri-mickey-fill "></i>
//                 <span className="ml-1">Toys</span>
//               </Link>
//             </li>
//           )}
//           {validatePermissionKey(props.authUser, VIEW_BOOKS) && (
//             <li id="bookList">
//               <Link id="bookLink" to="/books" className="waves-effect">
//                 <i className="ri-book-3-fill "></i>
//                 <span className="ml-1">Books</span>
//               </Link>
//             </li>
//           )}


const mapStateToProps = (state) => {
  return { ...state.Layout, authUser: state.Login?.user };
};

export default withRouter(
  connect(mapStateToProps, {
    changeLayout,
    changeSidebarTheme,
    changeSidebarType,
    changeLayoutWidth,
    changePreloader
  })(SidebarContent)
);